import { RoutablePage, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Prop, Watch, Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FAQ_NAMESPACE } from '../../store/modules/faq/faq.store.js';
import { store } from '../../store/index.js';
import { createFaqSearch } from '../../util/faq-search.js';

var faqModule = namespace(FAQ_NAMESPACE);
/**
 * Component displaying FAQ search results
 */
var FaqSearchComponent = /** @class */ (function (_super) {
    __extends(FaqSearchComponent, _super);
    function FaqSearchComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchResults = [];
        return _this;
    }
    Object.defineProperty(FaqSearchComponent.prototype, "hasSearchResults", {
        get: function () {
            return this.searchResults.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    FaqSearchComponent.prototype.fetchFAQData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.fetchEntries(this.magicConfig.language)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.routeTo({ route: RoutablePage.NOT_FOUND });
                        console.error(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    FaqSearchComponent.prototype.rebuildSearch = function () {
        if (!this.entries) {
            return;
        }
        this.searchFaqs = createFaqSearch(this.entries);
    };
    FaqSearchComponent.prototype.getSearchResults = function () {
        var query = this.query.trim().toLowerCase();
        if (query.length < this.minLength || !this.searchFaqs) {
            this.searchResults = [];
            return;
        }
        this.searchResults = this.searchFaqs(query, this.limit);
    };
    __decorate([
        Prop({ type: String, default: '' }),
        __metadata("design:type", String)
    ], FaqSearchComponent.prototype, "query", void 0);
    __decorate([
        Prop({ type: Number, default: 0 }),
        __metadata("design:type", Number)
    ], FaqSearchComponent.prototype, "minLength", void 0);
    __decorate([
        Prop({ type: Number, default: 100 }),
        __metadata("design:type", Number)
    ], FaqSearchComponent.prototype, "limit", void 0);
    __decorate([
        faqModule.Action('fetchEntries'),
        __metadata("design:type", Function)
    ], FaqSearchComponent.prototype, "fetchEntries", void 0);
    __decorate([
        faqModule.Getter('isLoading'),
        __metadata("design:type", void 0)
    ], FaqSearchComponent.prototype, "isLoading", void 0);
    __decorate([
        faqModule.Getter('entries'),
        __metadata("design:type", void 0)
    ], FaqSearchComponent.prototype, "entries", void 0);
    __decorate([
        Watch('magicConfig.language', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], FaqSearchComponent.prototype, "fetchFAQData", null);
    __decorate([
        Watch('entries', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FaqSearchComponent.prototype, "rebuildSearch", null);
    __decorate([
        Watch('query', { immediate: true }),
        Watch('entries'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], FaqSearchComponent.prototype, "getSearchResults", null);
    FaqSearchComponent = __decorate([
        Component({
            name: 'faq-search',
            store: store,
        })
    ], FaqSearchComponent);
    return FaqSearchComponent;
}(Mixins(MagicConfigMixin)));

export default FaqSearchComponent;
